import { useCallback, useEffect, useState } from 'react';

import { ErroRespostaHttp } from '../../../shared/api/http';
import { alterarRanking, listarTurmas } from '../api/ranking';
import type { RankingDaTurma } from '../api/ranking';

interface RankingPainelProps {
    csrfToken: string;
}

function mensagemDoErro(erro: unknown): string {
    if (erro instanceof ErroRespostaHttp) {
        if (typeof erro.corpo?.mensagem === 'string') return erro.corpo.mensagem;
        if (erro.status === 401 || erro.status === 403) return 'Sessão expirada ou sem permissão. Entre de novo.';
    }
    return 'Não foi possível salvar. Tente novamente.';
}

export function RankingPainel({ csrfToken }: RankingPainelProps) {
    const [turmas, setTurmas] = useState<RankingDaTurma[] | null>(null);
    const [erro, setErro] = useState<string | null>(null);
    const [ocupado, setOcupado] = useState(false);

    const carregar = useCallback(async () => {
        try {
            setTurmas(await listarTurmas());
        } catch (falha) {
            setTurmas([]);
            setErro(mensagemDoErro(falha));
        }
    }, []);

    useEffect(() => {
        void carregar();
    }, [carregar]);

    async function alternar(turma: RankingDaTurma) {
        setErro(null);
        setOcupado(true);
        try {
            const atualizada = await alterarRanking(turma.turma_id, !turma.ranking, csrfToken);
            setTurmas((atual) => (atual ?? []).map((item) => (item.turma_id === turma.turma_id ? atualizada : item)));
        } catch (falha) {
            // O estado só muda depois da resposta: na falha o switch segue como estava.
            setErro(mensagemDoErro(falha));
        } finally {
            setOcupado(false);
        }
    }

    if (turmas === null) return <p className="estado-variaveis">Carregando as turmas…</p>;

    return (
        <div className="cadastro">
            {erro && <p className="mensagem-login aviso-cadastro" role="alert">{erro}</p>}
            {turmas.map((turma) => (
                <label className="linha-ranking" key={turma.turma_id}>
                    <span>{turma.nome ?? turma.turma_id}</span>
                    <input
                        type="checkbox" role="switch" checked={turma.ranking} disabled={ocupado}
                        aria-label={`Ranking da turma ${turma.turma_id}`}
                        onChange={() => void alternar(turma)}
                    />
                </label>
            ))}
            <p className="nota-pontuacao">
                O ranking só aparece para os participantes da turma depois de ligado aqui.
            </p>
        </div>
    );
}
